export const FLOWLYTICS_PIXEL_WIZARD = 'flowlytics_pixel_wizard'
export const FLOWLYTICS_CONVERSIONS_PAGE = 'flowlytics_conversion_reports_page'
export const FLOWLYTICS_PIXEL_MANAGEMENT_V2 = 'flowlytics_pixel_management_v2'
export const FLOWLYTICS_COMPETITIVE_BENCHMARKING = 'flowlytics_competitive_benchmarking'
export const FLOWLYTICS_DATA_CAPS = 'flowlytics_data_caps'
export const DESKTOP_LOCG_AUTOBUILDER = 'desktop_locg_autobuilder'
export const AUTOBUILDER_TAB_DEFAULT = 'desktop_tab_default'
export const LOCG_LOGO_FIRST = 'locg_logo_first'
export const DESKTOP_LOCG_NEW_ELEMENTS_DRAWER = 'desktop_locg_new_elements_drawer'
export const LLM_FLOWCODE_GENERATOR = 'llm_flowcode_generator'
export const LLM_LABEL = 'llm_label'
export const LLM_PALETTE_POST_PROCESS = 'llm_palette_post_process'
